﻿

$(document).ready(function () {

    getAllFiles();

    $('.btnDeleteFiles').click(function () {
        var blockId = $(this).attr('id').split('_')[1];
        var selectedFiles = $('#hdnSelectedFiles' + blockId).val();
        if (selectedFiles != '') {
            if (confirm('Haluatko varmasti poistaa tiedostot?')) {
                var obj = {};
                obj.blockId = blockId;
                obj.fileIds = selectedFiles;
                $.ajax({
                    url: '/api/attachments/delete',
                    type: "POST",
                    data: JSON.stringify(obj),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (result) {
                        getAllFiles();
                    },
                    error: function (err) {
                        alert(err.statusText);
                    }
                });
            }
        }
        else {
            alert('Poistettavia tiedostoja ei ole valittu.');
        }
    });
    $(".selectFile").change(function () {
        var fileName = $(this).val();
        if (fileName != '') {
            if (window.FormData !== undefined) {
                var blockId = $(this).attr('id').split('_')[1];
                var fileUpload = $(this).get(0);
                var files = fileUpload.files;

                // Create FormData object
                var fileData = new FormData();

                // Looping over all files and add it to FormData object
                for (var i = 0; i < files.length; i++) {
                    fileData.append('files', files[i]);
                }
                // Adding one more key to FormData object
                fileData.append('folderId', $('#hdnSelectedFolder' + blockId).val());

                $.ajax({
                    url: '/api/attachments/submitform',
                    type: "POST",
                    contentType: false, // Not to set any content header
                    processData: false, // Not to process data
                    data: fileData,
                    success: function (result) {

                        $('#' + $('#hdnSelectedFolder' + blockId).val()).find('.folder_name').click();
                    },
                    error: function (err) {
                        alert(err.statusText);
                    }
                });
            } else {
                alert("FormData is not supported.");
            }

        }
    });

    $(document).on('click', '.newewFile', function () {
        //$('#fileUpload2').modal('show');
        //$("#fileUpload2").fadeIn();
        var blockId = $(this).closest('.file-tree').attr('id');
        $('#selectFile_' + blockId).click();
        $('#hdnSelectedFolder' + blockId).val($(this).parent().attr('id'));
    });
    $('.select').change(function () {
        var blockId = $(this).closest('.file-tree').attr('id');
        var arr = $('#hdnSelectedFolder' + blockId).val().split(',');
        if ($(this).checked) {
            if (!arr.indexOf($(this).val()) < 0) {
                arr.push($(this).val());
            }
        }
        else {
            if (arr.indexOf($(this).val()) > -1) {
                let index = arr.indexOf($(this).val());
                if (index != -1) {
                    arr.splice(index, 1); // remove 1 element from index
                }
            }
        }
        $('#hdnSelectedFolder' + blockId).val(arr.join(','));
    });
    $(document).on('change', '.chkFile', function () {
        var blockId = $(this).closest('.file-tree').attr('id');
        var fileIds = $('#hdnSelectedFiles' + blockId).val().split(',');
        var selectedFileId = $(this).attr('id').split('_')[1];
        if ($(this).is(":checked")) {
            if (fileIds.indexOf(selectedFileId) === -1) {
                fileIds.push(selectedFileId);
            }
        }
        else {
            if (fileIds.indexOf(selectedFileId) > -1) {
                fileIds.splice(fileIds.indexOf(selectedFileId), 1);
            }
        }
        $('#hdnSelectedFiles' + blockId).val(fileIds.join());
    });
    $(document).on('click', '.folder_name', function () {
        var blockId = $(this).closest('.file-tree').attr('id');
        var orderBy = $('#hdnOrderBy' + blockId).val();
        var folderId = $(this).parent().attr('id');
        if ($('#' + folderId).find('.childrens').css('display') == 'none') {
            if ($(this).find('ul').length == 0) {
                $.ajax({
                    type: 'GET',
                    url: '/api/attachments/getchildren?blockId=' + blockId + '&folderId=' + folderId + '&orderBy=' + orderBy,
                    dataType: 'json',
                    contentType: 'application/json',
                    success: function (data) {
                        var html = generateFileStructure(data);

                        $('#' + folderId).find('.childrens').html('').append(html);
                    }
                });

            }
        }
        $('#' + folderId).find('.childrens').toggle();
    });

});
function generateFileStructure(data, isRootFolder = false) {
    var html = '';
    var isUserAdmin = $('#hdnUserIsAdmin').val();
    if (isRootFolder) {
        if (data.IsFolder) {
            if (isUserAdmin == "True") {
                html += '<div id=\'' + data.Id + '\'><h4 class=\'folder_name\'  ><i class="icon  icon--folder"></i>\
' + data.Name + '</h4><label class="small-button newewFile" title="Lisää asiakirja"><i class="icon  icon--add-document"></i>\
</label><div class=\'childrens\' style=\'display:none;\'></div></div>';
            } else {
                html += '<div id=\'' + data.Id + '\'><h4 class=\'folder_name\'  ><i class="icon  icon--folder"></i>\
' + data.Name + '</h4><div class=\'childrens\' style=\'display:none;\'></div></div>';

            }
        }
        else {
            if (isUserAdmin == "True") {
                html += '<div class=\'layout__item u-1/1\'  id=\'' + data.Id + '\' ><input class=\'chkFile\' id=\'chk_' + data.Id + '\' type=\'checkbox\'/>\
<a href=\'' + data.Url + '\'><i class="icon  icon--document  document-management__file-icon"></i><span class=\'document-title\'>' + data.Name + '<br/>\
' + data.TimestampString + '</span></a></div>';
            } else {
                html += '<div class=\'layout__item u-1/1\'  id=\'' + data.Id + '\' ><a href=\'' + data.Url + '\'><i class="icon  icon--document  document-management__file-icon"></i>\
<span class=\'document-title\'>' + data.Name + '<br/>' + data.TimestampString + '</span></a></div>';

            }
        }
    }
    else {
        for (var j = 0; j < data.length; j++) {
            if (data[j].IsFolder) {
                if (isUserAdmin == "True") {
                    html += '<div id=\'' + data[j].Id + '\'><h4 class=\'folder_name\'  ><i class="icon  icon--folder"></i>\
' + data[j].Name + '</h4><label class="small-button newewFile" title="Lisää asiakirja"><i class="icon  icon--add-document"></i>\
</label><div class=\'childrens\' style=\'display:none;\'></div></div>';
                } else {
                    html += '<div id=\'' + data[j].Id + '\'><h4 class=\'folder_name\'  ><i class="icon  icon--folder"></i>\
' + data[j].Name + '</h4><div class=\'childrens\' style=\'display:none;\'></div></div>';

                }
            }
            else {
                if (isUserAdmin == "True") {
                    html += '<div class=\'layout__item u-1/1\'  id=\'' + data[j].Id + '\' ><input class=\'chkFile\' id=\'chk_' + data[j].Id + '\' type=\'checkbox\'/>\
<a href=\'' + data[j].Url + '\'><i class="icon  icon--document  document-management__file-icon"></i><span class=\'document-title\'>' + data[j].Name + '<br/>\
' + data[j].TimestampString + '</span></a></div>';
                } else {
                    html += '<div class=\'layout__item u-1/1\'  id=\'' + data[j].Id + '\' ><a href=\'' + data[j].Url + '\'><i class="icon  icon--document  document-management__file-icon"></i>\
<span class=\'document-title\'>' + data[j].Name + '<br/>' + data[j].TimestampString + '</span></a></div>';

                }
            }
        }
    }
    return html;
}
function getAllFiles() {
    if ($('.hdnblockId').length > 0) {

        $('.hdnblockId').each(function () {
            var blockId = $(this).val();
            var orderBy = $('#hdnOrderBy' + blockId).val();
            $.ajax({
                type: 'GET',
                url: '/api/attachments/getfiles?blockId=' + blockId + '&orderBy=' + orderBy,
                dataType: 'json',
                contentType: 'application/json',
                success: function (data) {
                    var html = '<div id="' + blockId + '" class=\"file-tree\">';
                    for (var i = 0; i < data.length; i++) {
                        var childrens = data[i];
                        html += generateFileStructure(childrens, true);
                    }
                    html += '</div>';
                    $('#divAttachments' + blockId).html(html);
                }
            });
        });
    }
}
